(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEYS = { walk: true, drive: true };

    function headerOffset() {
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wp-header-h'));
      if (!isNaN(v) && v > 0) return v;
      var header = document.querySelector('[data-wp-header]') || document.querySelector('header');
      return header ? header.getBoundingClientRect().height : 0;
    }

    function keyFromHash() {
      var key = (location.hash || '').slice(1);
      return KEYS[key] ? key : 'all';
    }

    function init(root) {
      if (!root || root.dataset.wpReady) return;
      root.dataset.wpReady = '1';

      var bar = root.querySelector('[data-wp-filters]');
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-wp-chip]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('.wp-collection__item'));
      var tile = root.querySelector('[data-wp-tile]');
      var countEl = root.querySelector('[data-wp-count]');
      var sort = root.querySelector('[data-wp-sort]');

      function apply(key) {
        var visible = [];
        items.forEach(function (item) {
          var groups = (item.getAttribute('data-wp-groups') || '').split(/\s+/);
          var show = key === 'all' || groups.indexOf(key) > -1;
          item.hidden = !show;
          if (show) visible.push(item);
        });
        chips.forEach(function (chip) {
          var on = chip.getAttribute('data-wp-chip') === key;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (tile) {
          if (visible.length > 3) {
            tile.hidden = false;
            if (visible[2].nextElementSibling !== tile) visible[2].after(tile);
          } else {
            tile.hidden = true;
          }
        }
        if (countEl) {
          var n = key === 'all' ? countEl.getAttribute('data-count-total') || visible.length : visible.length;
          countEl.textContent = (countEl.getAttribute('data-count-template') || '__N__').replace('__N__', n);
        }
        document.dispatchEvent(new CustomEvent('wp:filter', { detail: { key: key } }));
      }

      function jump() {
        if (!bar) return;
        if (window.WP && typeof window.WP.scrollToWithHeader === 'function') {
          window.WP.scrollToWithHeader(bar, 12);
          return;
        }
        var top = bar.getBoundingClientRect().top + window.scrollY - headerOffset() - 12;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      /* On load with a hash: scroll the filter bar under the header, retry every 100ms
         (up to 4s) until the position is stable while images load. */
      function settle() {
        var tries = 0;
        (function tick() {
          tries++;
          if (bar) {
            var off = headerOffset();
            var top = bar.getBoundingClientRect().top;
            if (Math.abs(top - off - 12) < 6) return;
            window.scrollTo({ top: top + window.scrollY - off - 12 });
          }
          if (tries < 40) setTimeout(tick, 100);
        })();
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var key = chip.getAttribute('data-wp-chip');
          history.replaceState(null, '', key === 'all' ? location.pathname + location.search : '#' + key);
          apply(key);
        });
      });

      window.addEventListener('hashchange', function () {
        apply(keyFromHash());
        if (KEYS[keyFromHash()]) setTimeout(jump, 50);
      });

      if (sort) {
        sort.addEventListener('change', function () {
          var url = new URL(location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          location.href = url.toString();
        });
      }

      apply(keyFromHash());
      if (KEYS[keyFromHash()]) setTimeout(settle, 100);
    }

    function run() {
      document.querySelectorAll('[data-wp-collection]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-details-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      /* After a successful notify submit, open the item that holds the thank-you state. */
      Array.prototype.forEach.call(scope.querySelectorAll('[data-wp-notify-done]'), function (done) {
        var details = done.closest('details');
        if (!details) return;
        var list = details.closest('[data-wp-accordion]');
        if (list) {
          Array.prototype.forEach.call(list.querySelectorAll('details'), function (d) { if (d !== details) d.open = false; });
        }
        details.open = true;
        if (!root && window.location.search.indexOf('customer_posted=true') !== -1) {
          details.scrollIntoView({ block: 'center' });
        }
      });
      /* Fallback single-open behaviour when the shared script is not loaded yet. */
      Array.prototype.forEach.call(scope.querySelectorAll('[data-wp-accordion]'), function (list) {
        if (list.wpDaSingle) return;
        list.wpDaSingle = true;
        list.addEventListener('toggle', function (e) {
          var target = e.target;
          if (!target || target.tagName !== 'DETAILS' || !target.open) return;
          if (window.WP && window.WP.accordionHandled) return;
          Array.prototype.forEach.call(list.querySelectorAll('details'), function (d) { if (d !== target && d.open) d.open = false; });
        }, true);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(header) {
      if (!header || header.dataset.wpHeaderInit === 'true') return;
      header.dataset.wpHeaderInit = 'true';

      /* Mobile menu toggle */
      var burger = header.querySelector('[data-wp-menu-toggle]');
      var menu = header.querySelector('[data-wp-mobile-menu]');
      if (burger && menu) {
        burger.addEventListener('click', function () {
          var open = burger.getAttribute('aria-expanded') === 'true';
          burger.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) {
            menu.setAttribute('hidden', '');
          } else {
            menu.removeAttribute('hidden');
          }
        });
        var closeMenu = function () {
          burger.setAttribute('aria-expanded', 'false');
          menu.setAttribute('hidden', '');
        };
        /* Close the menu as soon as a link is chosen, so the page is visible.
           Needed for same-page links like /collections/all#walk, which do not reload the page. */
        menu.addEventListener('click', function (event) {
          if (event.target.closest('a')) closeMenu();
        });
        header.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
            closeMenu();
            burger.focus();
          }
        });
        window.addEventListener('resize', function () {
          if (window.innerWidth >= 1080 && burger.getAttribute('aria-expanded') === 'true') {
            closeMenu();
          }
        });
      }

      /* Support dropdown (hover is CSS; click toggles for touch and keyboard) */
      var support = header.querySelector('[data-wp-support]');
      var supportBtn = header.querySelector('[data-wp-support-toggle]');
      if (support && supportBtn) {
        var setSupport = function (open) {
          support.classList.toggle('is-open', open);
          supportBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        supportBtn.addEventListener('click', function (event) {
          event.preventDefault();
          setSupport(!support.classList.contains('is-open'));
        });
        support.addEventListener('mouseenter', function () {
          supportBtn.setAttribute('aria-expanded', 'true');
        });
        support.addEventListener('mouseleave', function () {
          setSupport(false);
        });
        document.addEventListener('click', function (event) {
          if (!support.contains(event.target)) setSupport(false);
        });
        support.addEventListener('focusout', function (event) {
          if (!event.relatedTarget || !support.contains(event.relatedTarget)) setSupport(false);
        });
        header.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && support.classList.contains('is-open')) {
            setSupport(false);
            supportBtn.focus();
          }
        });
      }

      /* Language forms: buttons submit the localization form with their own locale_code */
      header.querySelectorAll('form.wp-header__lang, form.wp-header__lang-chip-form').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          var btn = event.submitter;
          if (!btn || !btn.value) return;
          var hidden = form.querySelector('input[name="locale_code"]');
          if (hidden) hidden.value = btn.value;
          /* Keep the #walk / #drive (or #faqs...) hash across the language switch */
          if (location.hash) {
            var returnTo = form.querySelector('input[name="return_to"]');
            if (returnTo) returnTo.value = returnTo.value.split('#')[0] + location.hash;
            try {
              sessionStorage.setItem('wp-lang-hash', JSON.stringify({ hash: location.hash, t: Date.now() }));
            } catch (e) {}
          }
        });
      });

      /* Fallback: restore the hash after the language redirect if it was dropped */
      try {
        var saved = JSON.parse(sessionStorage.getItem('wp-lang-hash') || 'null');
        sessionStorage.removeItem('wp-lang-hash');
        if (saved && saved.hash && !location.hash && Date.now() - saved.t < 30000) {
          history.replaceState(null, '', location.pathname + location.search + saved.hash);
          window.dispatchEvent(new HashChangeEvent('hashchange'));
        }
      } catch (e) {}

      /* Active underline for hash links (e.g. /collections/all#walk) */
      var hashLinks = header.querySelectorAll('.wp-header__link[data-wp-hash]');
      if (hashLinks.length) {
        var syncHash = function () {
          var hash = (location.hash || '').replace('#', '');
          var path = location.pathname.replace(/\/$/, '');
          hashLinks.forEach(function (link) {
            var linkPath = (link.pathname || '').replace(/\/$/, '');
            var active = hash !== '' && link.dataset.wpHash === hash && linkPath === path;
            link.classList.toggle('is-active', active);
            if (active) {
              link.setAttribute('aria-current', 'page');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        };
        syncHash();
        window.addEventListener('hashchange', syncHash);
        window.addEventListener('popstate', syncHash);
        /* The collection filter chips change the hash with replaceState (no hashchange event) */
        document.addEventListener('wp:filter', syncHash);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-wp-header]').forEach(initHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) {
      var header = event.target && event.target.querySelector ? event.target.querySelector('[data-wp-header]') : null;
      if (header) initHeader(header);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-order-lookup"] && !Shopify.designMode) return;
  try {
    
  /* Fallback form: switch between "order number" and "tracking number" fields. */
  (function () {
    function init(root) {
      if (!root || root.dataset.wpReady) return;
      root.dataset.wpReady = '1';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wp-mode]'));
      var fields = Array.prototype.slice.call(root.querySelectorAll('[data-wp-fields]'));
      var hints = Array.prototype.slice.call(root.querySelectorAll('[data-wp-hint]'));

      function show(mode) {
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-wp-mode') === mode;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        fields.forEach(function (group) {
          group.hidden = group.getAttribute('data-wp-fields') !== mode;
        });
        hints.forEach(function (hint) {
          hint.hidden = hint.getAttribute('data-wp-hint') !== mode;
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          show(tab.getAttribute('data-wp-mode'));
        });
      });
    }

    /* Track123: fetch the app proxy page and mount its tracker inside the card. */
    var T123_TIMEOUT = 12000;

    function t123Fail(card, box) {
      card.classList.remove('is-t123-loading');
      if (box) {
        box.hidden = true;
        box.replaceChildren();
      }
    }

    function t123Fetch(url) {
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (r) {
        if (!r.ok) throw new Error('Track123 ' + r.status);
        return r.text();
      });
    }

    function t123Clone(node) {
      /* Scripts parsed by DOMParser never run: rebuild them so they execute. */
      if (node.nodeName === 'SCRIPT') {
        var s = document.createElement('script');
        for (var i = 0; i < node.attributes.length; i++) {
          s.setAttribute(node.attributes[i].name, node.attributes[i].value);
        }
        s.textContent = node.textContent;
        return s;
      }
      return document.importNode(node, true);
    }

    function t123Mount(card) {
      if (!card || card.dataset.wpT123Init) return;
      card.dataset.wpT123Init = '1';
      var box = card.querySelector('[data-wp-t123-mount]');
      if (!box || !window.fetch || !window.DOMParser || document.getElementById('track123-app')) {
        t123Fail(card);
        return;
      }
      card.classList.add('is-t123-loading');
      var done = false;
      var timer = setTimeout(function () {
        if (!done) {
          done = true;
          t123Fail(card, box);
        }
      }, T123_TIMEOUT);

      function fail() {
        if (done) return;
        done = true;
        clearTimeout(timer);
        t123Fail(card, box);
      }

      var src = card.getAttribute('data-wp-t123-src') || '/apps/track123';
      var alt = card.getAttribute('data-wp-t123-fallback-src') || '/apps/track123';
      t123Fetch(src)
        .catch(function (err) {
          if (src === alt) throw err;
          return t123Fetch(alt);
        })
        .then(function (html) {
          if (done) return;
          /* The proxy page is the tracker document (its own head + body.track123-body) wrapped in
             the theme layout, so cut out that inner head and body by string before parsing. */
          var marker = '<body class="track123-body">';
          var a = html.indexOf(marker);
          var b = a < 0 ? -1 : html.indexOf('</body>', a);
          if (a < 0 || b < 0) throw new Error('Track123 markup not found');
          var h = html.lastIndexOf('<head>', a);
          var headInner = h < 0 ? '' : html.slice(h + 6, a).replace('</head>', '');
          var doc = new DOMParser().parseFromString(
            '<!doctype html><html><head></head><body>' + headInner + html.slice(a + marker.length, b) + '</body></html>',
            'text/html'
          );
          if (!doc.getElementById('track123-app')) throw new Error('Track123 app root not found');

          /* Stylesheets, inline styles, the config script, the app root and the module script, in order. */
          var nodes = [];
          doc.querySelectorAll('head > *, body > *').forEach(function (n) {
            if (/^(META|TITLE|BASE)$/.test(n.nodeName)) return;
            if (n.nodeName === 'LINK' && !/stylesheet/i.test(n.getAttribute('rel') || '')) return;
            nodes.push(n);
          });

          box.hidden = false;
          nodes.forEach(function (n) {
            box.appendChild(t123Clone(n));
          });
          function ready() {
            return !!box.querySelector('#track123_submit_button, .track123_form_wrapper');
          }
          function reveal() {
            if (done) return;
            done = true;
            clearTimeout(timer);
            card.classList.remove('is-t123-loading');
            card.classList.add('is-t123-ready');
          }
          if (ready()) {
            reveal();
            return;
          }
          var mo = new MutationObserver(function () {
            if (ready()) {
              mo.disconnect();
              reveal();
            }
          });
          mo.observe(box, { childList: true, subtree: true });
          setTimeout(function () {
            mo.disconnect();
          }, T123_TIMEOUT + 100);
        })
        .catch(fail);
    }

    function run() {
      document.querySelectorAll('[data-wp-lookup-form]').forEach(init);
      document.querySelectorAll('[data-wp-t123]').forEach(t123Mount);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-product-also"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function load(section) {
      if (section.wpProductAlso) return;
      section.wpProductAlso = true;
      var url = section.getAttribute('data-url');
      var grid = section.querySelector('[data-wp-pal-grid]');
      if (!url || !grid || !window.fetch) return;
      var own = section.getAttribute('data-product-id');
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 3;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-wp-pal-grid]');
          if (!fresh) return;
          var cards = Array.prototype.filter.call(fresh.querySelectorAll('[data-wp-pal-card]'), function (card) {
            return card.getAttribute('data-product-id') !== own;
          }).slice(0, limit);
          if (cards.length < Math.min(limit, grid.children.length)) return;
          grid.innerHTML = '';
          cards.forEach(function (card) { grid.appendChild(document.importNode(card, true)); });
        })
        .catch(function () { /* keep the fallback cards */ });
    }
    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      Array.prototype.forEach.call(scope.querySelectorAll('[data-wp-product-also]'), load);
      if (root && root.matches && root.matches('[data-wp-product-also]')) load(root);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-product-main"]) return;
  try {
    
  (function () {
    'use strict';
    var MOBILE = 860;
    var GAP = 12;

    /* Money formatting from the shop's money format string (cents in). */
    function formatMoney(cents, format) {
      var formatString = (format || ('€' + '{' + '{amount_with_comma_separator}' + '}')).replace(/<[^>]*>/g, '');
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      function withDelimiters(number, precision, thousands, decimal) {
        if (isNaN(number) || number === null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var match = formatString.match(placeholder);
      var key = match ? match[1] : 'amount';
      var value;
      switch (key) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
        case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
        default: value = withDelimiters(cents, 2, ',', '.');
      }
      return formatString.replace(placeholder, value);
    }

    function headerHeight() {
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wp-header-h'));
      return isNaN(v) ? 0 : v;
    }

    /* ---------------- Gallery ---------------- */
    function Gallery(root) {
      var self = this;
      this.root = root;
      this.frame = root.querySelector('[data-wp-gallery-frame]');
      this.viewport = root.querySelector('[data-wp-gallery-viewport]');
      this.track = root.querySelector('[data-wp-gallery-track]');
      this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-wp-gallery-slide]'));
      this.thumbsRow = root.querySelector('[data-wp-gallery-thumbs]');
      this.thumbs = this.thumbsRow ? Array.prototype.slice.call(this.thumbsRow.querySelectorAll('[data-wp-gallery-thumb]')) : [];
      this.counter = root.querySelector('[data-wp-gallery-counter]');
      this.n = this.slides.length;
      this.index = Math.max(0, Math.min(this.n - 1, parseInt(root.getAttribute('data-index'), 10) || 0));

      if (!this.track || !this.viewport || !this.frame) return;

      this.viewport.addEventListener('pointerdown', function (e) { self.loadAround(self.index); self.swipeStart(e); });
      /* Desktop: hovering the photo loads the neighbours before a click or arrow press. */
      this.frame.addEventListener('pointerenter', function () { self.loadAround(self.index); });
      var prev = root.querySelector('[data-wp-gallery-prev]');
      var next = root.querySelector('[data-wp-gallery-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo((self.index - 1 + self.n) % self.n); });
      if (next) next.addEventListener('click', function () { self.goTo((self.index + 1) % self.n); });
      this.thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { self.goTo(i); });
        thumb.addEventListener('pointerenter', function () { self.load(i); });
        thumb.addEventListener('focus', function () { self.load(i); });
      });
      /* Thumbnails after the 6th: loaded after the page load event, or as soon as the row is
         touched, scrolled or focused, or the gallery moves (goTo). */
      if (this.thumbsRow) {
        var thumbsNow = function () { self.loadThumbs(); };
        ['scroll', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
          self.thumbsRow.addEventListener(ev, thumbsNow, { passive: true, once: true });
        });
        if (document.readyState === 'complete') setTimeout(thumbsNow, 0);
        else window.addEventListener('load', thumbsNow);
      }
      this.viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self.goTo(Math.max(0, self.index - 1)); }
        if (e.key === 'ArrowRight') { self.goTo(Math.min(self.n - 1, self.index + 1)); }
      });
      sideClick(this.viewport, this);

      this.size(false);
      root.classList.add('is-sized');
      this.scrollThumb();
      /* Frame size changes animate (with the slide) only after the first paint. */
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-ready'); }); });
      if (window.ResizeObserver) {
        this.ro = new ResizeObserver(function () { self.size(); });
        this.ro.observe(root);
      }
      window.addEventListener('resize', function () { self.size(false); });
      window.addEventListener('load', function () { self.size(false); });
    }

    /*
      Desktop (fine pointer, >= 860px): clicking the right half of the image goes to the next image,
      the left half to the previous one (wrapping, like the arrows). Arrow buttons stay the keyboard path.
      A drag does not count: the swipe code swallows the click that follows it.
    */
    function sideClick(el, gallery) {
      var fine = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
      var active = function () { return !!(fine && fine.matches) && window.innerWidth >= MOBILE && gallery.n > 1; };
      var side = function (e) {
        var r = el.getBoundingClientRect();
        return e.clientX - r.left >= r.width / 2 ? 'next' : 'prev';
      };
      el.addEventListener('click', function (e) {
        if (!active() || e.defaultPrevented) return;
        if (e.target.closest && e.target.closest('button, a, input, select')) return;
        var n = gallery.n;
        gallery.goTo(side(e) === 'next' ? (gallery.index + 1) % n : (gallery.index - 1 + n) % n);
      });
      el.addEventListener('mousemove', function (e) {
        if (!active() || (e.target.closest && e.target.closest('button'))) { el.removeAttribute('data-side'); return; }
        el.setAttribute('data-side', side(e));
      });
      el.addEventListener('mouseleave', function () { el.removeAttribute('data-side'); });
    }

    /*
      Speed: only the first slide loads with the page. The other slides keep their URLs in
      data-wp-srcset / data-wp-src (on the <source> and the <img>) until they are needed.
    */
    Gallery.prototype.load = function (i) {
      var slide = this.slides[i];
      if (!slide || slide.wpLoaded) return;
      slide.wpLoaded = true;
      var els = slide.querySelectorAll('[data-wp-srcset], [data-wp-src]');
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        var set = el.getAttribute('data-wp-srcset');
        if (set) { el.setAttribute('srcset', set); el.removeAttribute('data-wp-srcset'); }
        var src = el.getAttribute('data-wp-src');
        if (src) { el.setAttribute('src', src); el.removeAttribute('data-wp-src'); }
      }
    };

    Gallery.prototype.loadThumbs = function () {
      if (this.thumbsLoaded || !this.thumbsRow) return;
      this.thumbsLoaded = true;
      var els = this.thumbsRow.querySelectorAll('[data-wp-srcset], [data-wp-src]');
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        var set = el.getAttribute('data-wp-srcset');
        if (set) { el.setAttribute('srcset', set); el.removeAttribute('data-wp-srcset'); }
        var src = el.getAttribute('data-wp-src');
        if (src) { el.setAttribute('src', src); el.removeAttribute('data-wp-src'); }
      }
    };

    Gallery.prototype.loadAround = function (i) {
      if (!this.n) return;
      this.load(i);
      if (this.n > 1) {
        this.load((i + 1) % this.n);
        this.load((i - 1 + this.n) % this.n);
      }
    };

    Gallery.prototype.ratio = function (i) {
      var slide = this.slides[i];
      var r = slide ? parseFloat(slide.getAttribute('data-ratio')) : 1;
      return r > 0 ? r : 1;
    };

    /* Frame takes the natural ratio of the current image, capped in height (design galW/galH). */
    /* animate === false: jump (first paint, window resize); otherwise the frame follows with the slide easing. */
    Gallery.prototype.size = function (animate) {
      var gw = this.root.clientWidth;
      if (!gw) return;
      var root = this.root;
      if (animate === false && root.classList.contains('is-ready')) {
        root.classList.remove('is-ready');
        clearTimeout(this.readyT);
        this.readyT = setTimeout(function () { root.classList.add('is-ready'); }, 50);
      }
      var r = this.ratio(this.index);
      var mob = window.innerWidth < MOBILE;
      var maxH = mob ? Math.min(window.innerHeight * 0.52, 420) : Math.min(window.innerHeight * 0.76, 640);
      var H = Math.min(gw / r, maxH);
      this.frame.style.width = Math.round(H * r) + 'px';
      this.viewport.style.height = Math.round(H) + 'px';
    };

    Gallery.prototype.transform = function (i, px) {
      return 'translateX(calc(' + (-i * 100) + '% - ' + (i * GAP) + 'px + ' + (px || 0) + 'px))';
    };

    Gallery.prototype.goTo = function (i) {
      if (!this.n) return;
      i = Math.max(0, Math.min(this.n - 1, i));
      this.index = i;
      this.loadAround(i);
      this.loadThumbs();
      this.track.style.transition = '';
      this.track.style.transform = this.transform(i, 0);
      this.size();
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.n;
      this.thumbs.forEach(function (thumb, k) {
        thumb.classList.toggle('is-active', k === i);
        if (k === i) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
      this.scrollThumb();
    };

    Gallery.prototype.goToMedia = function (mediaId) {
      if (!mediaId) return false;
      for (var i = 0; i < this.slides.length; i++) {
        if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) { this.goTo(i); return true; }
      }
      return false;
    };

    Gallery.prototype.scrollThumb = function () {
      var row = this.thumbsRow, t = this.thumbs[this.index];
      if (!row || !t) return;
      if (this.lastThumb === this.index) return;
      this.lastThumb = this.index;
      var target = t.offsetLeft - this.thumbs[0].offsetLeft - (row.clientWidth - t.clientWidth) / 2;
      row.style.scrollSnapType = 'none';
      row.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      clearTimeout(this.thT);
      this.thT = setTimeout(function () { row.style.scrollSnapType = ''; }, 500);
    };

    /* Drag / swipe: follows the pointer, snaps on release (design swipeStart). */
    Gallery.prototype.swipeStart = function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (this.n < 2) return;
      var self = this, el = this.track, box = this.viewport;
      var doc = el.ownerDocument, W = box.clientWidth, n = this.n, i0 = this.index;
      var x0 = e.clientX, y0 = e.clientY, t0 = performance.now();
      var axis = null, dx = 0;
      var move = function (ev) {
        var mx = ev.clientX - x0, my = ev.clientY - y0;
        if (!axis) {
          if (Math.hypot(mx, my) < 6) return;
          axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (axis === 'x') el.style.transition = 'none';
        }
        if (axis !== 'x') return;
        dx = mx;
        var edge = (i0 === 0 && dx > 0) || (i0 === n - 1 && dx < 0);
        el.style.transform = self.transform(i0, edge ? dx / 3 : dx);
      };
      var up = function () {
        doc.removeEventListener('pointermove', move, true);
        doc.removeEventListener('pointerup', up, true);
        doc.removeEventListener('pointercancel', up, true);
        var block = function (c) { c.stopPropagation(); c.preventDefault(); };
        if (axis !== 'x') {
          /* a vertical drag is not a click either */
          if (axis) {
            doc.addEventListener('click', block, { capture: true, once: true });
            setTimeout(function () { doc.removeEventListener('click', block, true); }, 50);
          }
          return;
        }
        var v = dx / Math.max(1, performance.now() - t0);
        var i = i0;
        if (dx < -W * 0.18 || v < -0.4) i = Math.min(n - 1, i0 + 1);
        else if (dx > W * 0.18 || v > 0.4) i = Math.max(0, i0 - 1);
        el.style.transition = '';
        if (i !== i0) self.goTo(i); else el.style.transform = self.transform(i0, 0);
        doc.addEventListener('click', block, { capture: true, once: true });
        setTimeout(function () { doc.removeEventListener('click', block, true); }, 50);
      };
      doc.addEventListener('pointermove', move, true);
      doc.addEventListener('pointerup', up, true);
      doc.addEventListener('pointercancel', up, true);
    };

    /* ---------------- Variant picker + buy box ---------------- */
    function ProductMain(section) {
      var self = this;
      this.section = section;
      var variantsEl = section.querySelector('[data-wp-variants]');
      var namesEl = section.querySelector('[data-wp-option-names]');
      try { this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (err) { this.variants = []; }
      try { this.optionNames = namesEl ? JSON.parse(namesEl.textContent) : []; } catch (err) { this.optionNames = []; }
      this.moneyFormat = section.getAttribute('data-money-format') || '';
      this.monsterAddLabel = section.getAttribute('data-wp-monster-add-label') || '';
      this.colourIndex = parseInt(section.getAttribute('data-colour-index'), 10);
      if (isNaN(this.colourIndex)) this.colourIndex = -1;

      this.form = section.querySelector('[data-wp-product-form]');
      this.idInput = section.querySelector('[data-wp-variant-id]');
      this.addBtn = section.querySelector('[data-wp-add]');
      this.stickyBtn = section.querySelector('[data-wp-sticky-add]');
      this.stickyBar = section.querySelector('[data-wp-sticky]');
      this.stickyOptions = section.querySelector('[data-wp-sticky-options]');
      this.prices = Array.prototype.slice.call(section.querySelectorAll('[data-wp-price]'));
      this.rows = Array.prototype.slice.call(section.querySelectorAll('[data-wp-option]'));
      this.galleryEl = section.querySelector('[data-wp-gallery]');
      this.gallery = this.galleryEl ? this.galleryEl.wpGallery : null;

      /* Current selection from the pre-selected buttons. */
      this.selected = [];
      this.rows.forEach(function (row) {
        var idx = parseInt(row.getAttribute('data-wp-option-index'), 10);
        var on = row.querySelector('[data-wp-option-button].is-selected');
        self.selected[idx] = on ? on.getAttribute('data-value') : null;
      });
      this.current = this.resolve();
      if (!this.current && this.idInput) {
        var id = String(this.idInput.value);
        this.current = this.variants.filter(function (v) { return String(v.id) === id; })[0] || null;
      }
      this.markAvailability();

      this.rows.forEach(function (row) {
        var idx = parseInt(row.getAttribute('data-wp-option-index'), 10);
        Array.prototype.forEach.call(row.querySelectorAll('[data-wp-option-button]'), function (btn) {
          btn.addEventListener('click', function () { self.pick(idx, btn.getAttribute('data-value'), row); });
        });
      });

      if (this.form) {
        this.form.addEventListener('submit', function () { self.submitting(); });
      }
      if (this.stickyBtn && this.form) {
        this.stickyBtn.addEventListener('click', function () {
          if (self.addBtn && self.addBtn.disabled) return;
          if (self.addBtn) {
            self.addBtn.click();
          } else if (typeof self.form.requestSubmit === 'function') {
            self.form.requestSubmit();
          } else if (window.WP && typeof window.WP.addToCart === 'function') {
            window.WP.addToCart(new FormData(self.form));
          } else {
            self.form.submit();
          }
        });
      }

      var sizeGuide = section.querySelector('[data-wp-open-size-guide]');
      if (sizeGuide) {
        sizeGuide.addEventListener('click', function (e) {
          var item = document.querySelector('[data-wp-size-guide]');
          if (!item) return;
          e.preventDefault();
          var details = item.tagName === 'DETAILS' ? item : item.closest('details');
          if (details) {
            var list = details.closest('[data-wp-accordion]');
            if (list) {
              Array.prototype.forEach.call(list.querySelectorAll('details'), function (d) { if (d !== details) d.open = false; });
            }
            details.open = true;
          }
          var target = document.getElementById('details') || details || item;
          if (window.WP && typeof window.WP.scrollToWithHeader === 'function') {
            window.WP.scrollToWithHeader(target, 12);
          } else {
            var y = target.getBoundingClientRect().top + window.scrollY - headerHeight() - 12;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        });
      }

      this.stickyPadding();
      window.addEventListener('resize', function () { self.stickyPadding(); });

      /* Monster Cart's sticky bar starts on the product's first variant; keep it on ours (it renders late). */
      var tries = 0;
      var poll = function () {
        self.syncMonster();
        if (++tries < 20) setTimeout(poll, 750);
      };
      poll();
    }

    /* Clicking an option in Monster's picker can leave its list dropped open: close it again (clicking its current value toggles it). */
    function closeMonsterList(box) {
      if (!box) return;
      var close = function () {
        if (box.isConnected && box.getAttribute('data-open') === 'open') {
          var cur = box.querySelector('[class*="_current_"]') || box;
          cur.click();
        }
      };
      setTimeout(close, 0);
      setTimeout(close, 200);
    }

    /* Localized label on Monster's sticky Add to cart button (Monster's own text is English-only).
       Never write the button's text: Monster owns that text node and re-inserts its own ("CONFIRM") next to ours
       after an add, which showed as "In winkelwagenCONFIRM". We only set data-wp-label / aria-label;
       monster-overrides.css hides Monster's text and shows the label via ::after. */
    ProductMain.prototype.syncMonsterButtonText = function () {
      var self = this;
      var label = this.monsterAddLabel;
      if (!label) return;
      var root = document.getElementById('monster-upsell-sticky-cart');
      if (!root) return;
      var buttons = root.querySelectorAll('.mu_sticky_mobile_atc, .mu_sticky_descktop_atc');
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].getAttribute('data-wp-label') !== label) {
          buttons[i].setAttribute('data-wp-label', label);
          buttons[i].setAttribute('aria-label', label);
        }
      }
      /* Monster renders late and can re-create the button: label new ones. Only childList is observed and we only
         change attributes, so our own writes never re-trigger the observer. */
      if (window.MutationObserver && !root.__wpObserved) {
        root.__wpObserved = true;
        new MutationObserver(function () { self.syncMonsterButtonText(); })
          .observe(root, { childList: true, subtree: true });
      }
    };

    /* Selects our current options in Monster Cart's sticky-bar pickers (its own form then carries our variant). */
    ProductMain.prototype.syncMonster = function () {
      this.syncMonsterButtonText();
      var root = document.getElementById('monster-upsell-sticky-cart');
      var variant = this.current;
      if (!root || !variant || !variant.options) return;
      var bars = root.querySelectorAll('.mu_sticky_mobile, .mu_sticky_descktop');
      Array.prototype.forEach.call(bars.length ? bars : [root], function (bar) {
        var selects = bar.querySelectorAll('[class*="_map_select_containar_"]');
        Array.prototype.forEach.call(selects, function (sel, i) {
          var value = variant.options[i];
          if (value === undefined) return;
          var items = sel.querySelectorAll('li[data-display]');
          for (var k = 0; k < items.length; k++) {
            var li = items[k];
            if (li.getAttribute('data-display') !== value) continue;
            if (!/_selected_/.test(li.className)) {
              var box = li.closest('[data-open]') || sel.querySelector('[data-open]');
              li.click();
              closeMonsterList(box);
            }
            break;
          }
        });
      });
    };

    ProductMain.prototype.resolve = function () {
      var sel = this.selected;
      if (!sel.length) return this.variants[0] || null;
      for (var v = 0; v < this.variants.length; v++) {
        var variant = this.variants[v], ok = true;
        for (var i = 0; i < sel.length; i++) {
          if (sel[i] !== undefined && sel[i] !== null && variant.options[i] !== sel[i]) { ok = false; break; }
        }
        if (ok) return variant;
      }
      return null;
    };

    ProductMain.prototype.pick = function (idx, value, row) {
      var self = this;
      this.selected[idx] = value;
      Array.prototype.forEach.call(row.querySelectorAll('[data-wp-option-button]'), function (btn) {
        var on = btn.getAttribute('data-value') === value;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var label = row.querySelector('[data-wp-option-value]');
      if (label) label.textContent = value;

      this.current = this.resolve();
      this.apply(this.current);
      this.markAvailability();
      /* Monster can reset its other picker after a change, so check again shortly after. */
      this.syncMonster();
      clearTimeout(this.monsterT1);
      clearTimeout(this.monsterT2);
      this.monsterT1 = setTimeout(function () { self.syncMonster(); }, 350);
      this.monsterT2 = setTimeout(function () { self.syncMonster(); }, 900);

      if (idx === this.colourIndex) {
        if (this.gallery && this.current && this.current.featured_media) {
          this.gallery.goToMedia(this.current.featured_media.id);
        }
        this.toGallery();
      }
      self.section.dispatchEvent(new CustomEvent('wp:variant:change', { detail: { variant: this.current } }));
    };

    ProductMain.prototype.apply = function (variant) {
      var self = this;
      var addLabel = this.addBtn ? this.addBtn.getAttribute('data-label-add') : '';
      var soldLabel = this.addBtn ? this.addBtn.getAttribute('data-label-sold-out') : '';
      var unavailableLabel = this.addBtn ? this.addBtn.getAttribute('data-label-unavailable') : '';
      var label, disabled;
      if (!variant) { label = unavailableLabel; disabled = true; }
      else if (!variant.available) { label = soldLabel; disabled = true; }
      else { label = addLabel; disabled = false; }
      [this.addBtn, this.stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = disabled;
        btn.textContent = label;
      });
      if (!variant) return;
      if (this.idInput) this.idInput.value = variant.id;
      this.prices.forEach(function (el) { el.textContent = formatMoney(variant.price, self.moneyFormat); });
      if (this.stickyOptions) this.stickyOptions.textContent = variant.options.join(' · ');
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* ignore */ }
    };

    /* Mark values that have no purchasable variant with the other selections. */
    ProductMain.prototype.markAvailability = function () {
      var self = this;
      this.rows.forEach(function (row) {
        var idx = parseInt(row.getAttribute('data-wp-option-index'), 10);
        Array.prototype.forEach.call(row.querySelectorAll('[data-wp-option-button]'), function (btn) {
          var value = btn.getAttribute('data-value');
          var exists = self.variants.some(function (variant) {
            if (!variant.available || variant.options[idx] !== value) return false;
            for (var i = 0; i < self.selected.length; i++) {
              if (i === idx) continue;
              if (self.selected[i] !== undefined && self.selected[i] !== null && variant.options[i] !== self.selected[i]) return false;
            }
            return true;
          });
          btn.classList.toggle('is-unavailable', !exists);
        });
      });
    };

    /* Mobile only: scroll back up to the gallery after a colour change. */
    ProductMain.prototype.toGallery = function () {
      var el = this.galleryEl;
      if (!el || window.innerWidth >= MOBILE) return;
      var y = el.getBoundingClientRect().top + window.scrollY - headerHeight() - 12;
      if (window.scrollY <= y) return;
      if (window.WP && typeof window.WP.scrollToWithHeader === 'function') {
        window.WP.scrollToWithHeader(el, 12);
      } else {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    };

    /* While adding: disable the buttons, keep the label. Re-enable after the drawer had time to open. */
    ProductMain.prototype.submitting = function () {
      var self = this;
      [this.addBtn, this.stickyBtn].forEach(function (btn) { if (btn) btn.disabled = true; });
      clearTimeout(this.submitTimer);
      this.submitTimer = setTimeout(function () {
        var ok = self.current && self.current.available;
        [self.addBtn, self.stickyBtn].forEach(function (btn) { if (btn) btn.disabled = !ok; });
      }, 2500);
    };

    ProductMain.prototype.stickyPadding = function () {
      if (!this.stickyBar) return;
      var mob = window.innerWidth < MOBILE;
      document.body.style.paddingBottom = mob ? this.stickyBar.offsetHeight + 'px' : '';
    };

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var sections = Array.prototype.slice.call(scope.querySelectorAll('[data-wp-product-main]'));
      if (root && root.matches && root.matches('[data-wp-product-main]')) sections.push(root);
      sections.forEach(function (section) {
        if (section.wpProductMain) return;
        var galleryEl = section.querySelector('[data-wp-gallery]');
        if (galleryEl && !galleryEl.wpGallery) galleryEl.wpGallery = new Gallery(galleryEl);
        section.wpProductMain = new ProductMain(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-product-standard"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var MOBILE = 860;
    var GAP = 12;

    function formatMoney(cents, format) {
      var formatString = (format || ('€' + '{' + '{amount_with_comma_separator}' + '}')).replace(/<[^>]*>/g, '');
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      function withDelimiters(number, precision, thousands, decimal) {
        if (isNaN(number) || number === null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var match = formatString.match(placeholder);
      var key = match ? match[1] : 'amount';
      var value;
      switch (key) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
        case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
        default: value = withDelimiters(cents, 2, ',', '.');
      }
      return formatString.replace(placeholder, value);
    }

    function each(list, fn) { Array.prototype.forEach.call(list, fn); }

    /* ---------------- Gallery (design: Product Standard swipeStart / prev / next) ---------------- */
    function Gallery(root) {
      var self = this;
      this.root = root;
      this.frame = root.querySelector('[data-wp-ps-viewport]');
      this.track = root.querySelector('[data-wp-ps-track]');
      this.slides = root.querySelectorAll('[data-wp-ps-slide]');
      this.thumbsRow = root.querySelector('[data-wp-ps-thumbs]');
      this.thumbs = this.thumbsRow ? this.thumbsRow.querySelectorAll('[data-wp-ps-thumb]') : [];
      this.counter = root.querySelector('[data-wp-ps-counter]');
      this.n = this.slides.length;
      this.index = Math.max(0, Math.min(this.n - 1, parseInt(root.getAttribute('data-index'), 10) || 0));
      if (!this.frame || !this.track) return;

      this.frame.addEventListener('pointerdown', function (e) { self.swipeStart(e); });
      var prev = root.querySelector('[data-wp-ps-prev]');
      var next = root.querySelector('[data-wp-ps-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo((self.index - 1 + self.n) % self.n); });
      if (next) next.addEventListener('click', function () { self.goTo((self.index + 1) % self.n); });
      each(this.thumbs, function (thumb, i) {
        thumb.addEventListener('click', function () { self.goTo(i); });
      });
      this.frame.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.goTo(Math.max(0, self.index - 1));
        if (e.key === 'ArrowRight') self.goTo(Math.min(self.n - 1, self.index + 1));
      });
      sideClick(this.frame, this);
    }

    /*
      Desktop (fine pointer, >= 860px): clicking the right half of the image goes to the next image,
      the left half to the previous one (wrapping, like the arrows). The arrow buttons inside the frame
      are ignored here (they have their own handler). A drag does not count: the swipe swallows that click.
    */
    function sideClick(el, gallery) {
      var fine = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
      var active = function () { return !!(fine && fine.matches) && window.innerWidth >= 860 && gallery.n > 1; };
      var side = function (e) {
        var r = el.getBoundingClientRect();
        return e.clientX - r.left >= r.width / 2 ? 'next' : 'prev';
      };
      el.addEventListener('click', function (e) {
        if (!active() || e.defaultPrevented) return;
        if (e.target.closest && e.target.closest('button, a, input, select')) return;
        var n = gallery.n;
        gallery.goTo(side(e) === 'next' ? (gallery.index + 1) % n : (gallery.index - 1 + n) % n);
      });
      el.addEventListener('mousemove', function (e) {
        if (!active() || (e.target.closest && e.target.closest('button'))) { el.removeAttribute('data-side'); return; }
        el.setAttribute('data-side', side(e));
      });
      el.addEventListener('mouseleave', function () { el.removeAttribute('data-side'); });
    }

    Gallery.prototype.transform = function (i, px) {
      return 'translateX(calc(' + (-i * 100) + '% - ' + (i * GAP) + 'px + ' + (px || 0) + 'px))';
    };

    Gallery.prototype.goTo = function (i) {
      if (!this.n) return;
      i = Math.max(0, Math.min(this.n - 1, i));
      this.index = i;
      this.track.style.transition = '';
      this.track.style.transform = this.transform(i, 0);
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.n;
      each(this.thumbs, function (thumb, k) {
        thumb.classList.toggle('is-active', k === i);
        if (k === i) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
      var t = this.thumbs[i], row = this.thumbsRow;
      if (t && row && row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: Math.max(0, t.offsetLeft - row.offsetLeft - (row.clientWidth - t.clientWidth) / 2), behavior: 'smooth' });
      }
    };

    Gallery.prototype.goToMedia = function (mediaId) {
      if (!mediaId) return false;
      for (var i = 0; i < this.slides.length; i++) {
        if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) { this.goTo(i); return true; }
      }
      return false;
    };

    Gallery.prototype.swipeStart = function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (this.n < 2) return;
      var self = this, el = this.track, doc = el.ownerDocument;
      var W = this.frame.clientWidth, n = this.n, i0 = this.index;
      var x0 = e.clientX, y0 = e.clientY, t0 = performance.now();
      var axis = null, dx = 0;
      var move = function (ev) {
        var mx = ev.clientX - x0, my = ev.clientY - y0;
        if (!axis) {
          if (Math.hypot(mx, my) < 6) return;
          axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (axis === 'x') el.style.transition = 'none';
        }
        if (axis !== 'x') return;
        dx = mx;
        var edge = (i0 === 0 && dx > 0) || (i0 === n - 1 && dx < 0);
        el.style.transform = self.transform(i0, edge ? dx / 3 : dx);
      };
      var up = function () {
        doc.removeEventListener('pointermove', move, true);
        doc.removeEventListener('pointerup', up, true);
        doc.removeEventListener('pointercancel', up, true);
        var block = function (c) { c.stopPropagation(); c.preventDefault(); };
        if (axis !== 'x') {
          /* a vertical drag is not a click either */
          if (axis) {
            doc.addEventListener('click', block, { capture: true, once: true });
            setTimeout(function () { doc.removeEventListener('click', block, true); }, 50);
          }
          return;
        }
        var v = dx / Math.max(1, performance.now() - t0);
        var i = i0;
        if (dx < -W * 0.18 || v < -0.4) i = Math.min(n - 1, i0 + 1);
        else if (dx > W * 0.18 || v > 0.4) i = Math.max(0, i0 - 1);
        el.style.transition = '';
        if (i !== i0) self.goTo(i); else el.style.transform = self.transform(i0, 0);
        doc.addEventListener('click', block, { capture: true, once: true });
        setTimeout(function () { doc.removeEventListener('click', block, true); }, 50);
      };
      doc.addEventListener('pointermove', move, true);
      doc.addEventListener('pointerup', up, true);
      doc.addEventListener('pointercancel', up, true);
    };

    /* ---------------- Buy box ---------------- */
    function ProductStandard(section) {
      var self = this;
      this.section = section;
      var variantsEl = section.querySelector('[data-wp-variants]');
      try { this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (err) { this.variants = []; }
      this.moneyFormat = section.getAttribute('data-money-format') || '';
      this.colourIndex = parseInt(section.getAttribute('data-colour-index'), 10);
      if (isNaN(this.colourIndex)) this.colourIndex = -1;

      this.form = section.querySelector('[data-wp-product-form]');
      this.idInput = section.querySelector('[data-wp-variant-id]');
      this.addBtn = section.querySelector('[data-wp-add]');
      this.prices = section.querySelectorAll('[data-wp-price]');
      this.rows = section.querySelectorAll('[data-wp-option]');
      this.galleryEl = section.querySelector('[data-wp-ps-gallery]');
      this.gallery = this.galleryEl ? this.galleryEl.wpPsGallery : null;

      /* Start from the rendered variant, so hidden single-value options stay selected too. */
      var id = this.idInput ? String(this.idInput.value) : '';
      this.current = this.variants.filter(function (v) { return String(v.id) === id; })[0] || this.variants[0] || null;
      this.selected = this.current ? this.current.options.slice() : [];
      this.markAvailability();

      each(this.rows, function (row) {
        var idx = parseInt(row.getAttribute('data-wp-option-index'), 10);
        each(row.querySelectorAll('[data-wp-option-button]'), function (btn) {
          btn.addEventListener('click', function () { self.pick(idx, btn.getAttribute('data-value'), row); });
        });
      });

      /* Quantity stepper 1 to 10 */
      this.qtyInput = section.querySelector('[data-wp-qty-input]');
      this.qtyDec = section.querySelector('[data-wp-qty-dec]');
      this.qtyInc = section.querySelector('[data-wp-qty-inc]');
      if (this.qtyDec) this.qtyDec.addEventListener('click', function () { self.setQty(self.qty() - 1); });
      if (this.qtyInc) this.qtyInc.addEventListener('click', function () { self.setQty(self.qty() + 1); });

      if (this.form) this.form.addEventListener('submit', function () { self.submitting(); });

      /* Long fallback description: clamp to five lines with a Read more toggle. */
      each(section.querySelectorAll('[data-wp-ps-more]'), function (wrap) {
        var body = wrap.querySelector('[data-wp-ps-more-body]');
        var btn = wrap.querySelector('[data-wp-ps-more-toggle]');
        if (!body || !btn) return;
        if (body.scrollHeight > 26 * 6) {
          wrap.classList.add('is-clamped');
          btn.hidden = false;
          btn.addEventListener('click', function () {
            wrap.classList.remove('is-clamped');
            btn.hidden = true;
          });
        }
      });
    }

    ProductStandard.prototype.qty = function () {
      var v = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10);
      return isNaN(v) ? 1 : v;
    };

    ProductStandard.prototype.setQty = function (v) {
      v = Math.max(1, Math.min(10, v));
      if (this.qtyInput) this.qtyInput.value = v;
      if (this.qtyDec) this.qtyDec.disabled = v <= 1;
      if (this.qtyInc) this.qtyInc.disabled = v >= 10;
    };

    ProductStandard.prototype.resolve = function () {
      var sel = this.selected;
      for (var v = 0; v < this.variants.length; v++) {
        var variant = this.variants[v], ok = true;
        for (var i = 0; i < sel.length; i++) {
          if (sel[i] != null && variant.options[i] !== sel[i]) { ok = false; break; }
        }
        if (ok) return variant;
      }
      return null;
    };

    ProductStandard.prototype.pick = function (idx, value, row) {
      this.selected[idx] = value;
      each(row.querySelectorAll('[data-wp-option-button]'), function (btn) {
        var on = btn.getAttribute('data-value') === value;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var label = row.querySelector('[data-wp-option-value]');
      if (label) label.textContent = value;

      this.current = this.resolve();
      this.apply(this.current);
      this.markAvailability();

      if (this.gallery && this.current && this.current.featured_media) {
        this.gallery.goToMedia(this.current.featured_media.id);
        if (idx === this.colourIndex) this.toGallery();
      }
      this.section.dispatchEvent(new CustomEvent('wp:variant:change', { detail: { variant: this.current } }));
    };

    ProductStandard.prototype.apply = function (variant) {
      var self = this, btn = this.addBtn;
      if (btn) {
        if (!variant) { btn.textContent = btn.getAttribute('data-label-unavailable'); btn.disabled = true; }
        else if (!variant.available) { btn.textContent = btn.getAttribute('data-label-sold-out'); btn.disabled = true; }
        else { btn.textContent = btn.getAttribute('data-label-add'); btn.disabled = false; }
      }
      if (!variant) return;
      if (this.idInput) this.idInput.value = variant.id;
      each(this.prices, function (el) { el.textContent = formatMoney(variant.price, self.moneyFormat); });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* ignore */ }
    };

    ProductStandard.prototype.markAvailability = function () {
      var self = this;
      each(this.rows, function (row) {
        var idx = parseInt(row.getAttribute('data-wp-option-index'), 10);
        each(row.querySelectorAll('[data-wp-option-button]'), function (btn) {
          var value = btn.getAttribute('data-value');
          var exists = self.variants.some(function (variant) {
            if (!variant.available || variant.options[idx] !== value) return false;
            for (var i = 0; i < self.selected.length; i++) {
              if (i !== idx && self.selected[i] != null && variant.options[i] !== self.selected[i]) return false;
            }
            return true;
          });
          btn.classList.toggle('is-unavailable', !exists);
        });
      });
    };

    /* Mobile: after a colour change, bring the gallery back into view. */
    ProductStandard.prototype.toGallery = function () {
      var el = this.galleryEl;
      if (!el || window.innerWidth >= MOBILE) return;
      var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wp-header-h')) || 0;
      var y = el.getBoundingClientRect().top + window.scrollY - hh - 12;
      if (window.scrollY <= y) return;
      if (window.WP && typeof window.WP.scrollToWithHeader === 'function') window.WP.scrollToWithHeader(el, 12);
      else window.scrollTo({ top: y, behavior: 'smooth' });
    };

    /* Same as the hero pages: disable while Monster Cart adds, re-enable after the drawer had time to open. */
    ProductStandard.prototype.submitting = function () {
      var self = this;
      if (this.addBtn) this.addBtn.disabled = true;
      clearTimeout(this.submitTimer);
      this.submitTimer = setTimeout(function () {
        if (self.addBtn) self.addBtn.disabled = !(self.current && self.current.available);
      }, 2500);
    };

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var sections = Array.prototype.slice.call(scope.querySelectorAll('[data-wp-product-standard]'));
      if (root && root.matches && root.matches('[data-wp-product-standard]')) sections.push(root);
      sections.forEach(function (section) {
        if (section.wpProductStandard) return;
        var galleryEl = section.querySelector('[data-wp-ps-gallery]');
        if (galleryEl && !galleryEl.wpPsGallery) galleryEl.wpPsGallery = new Gallery(galleryEl);
        section.wpProductStandard = new ProductStandard(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-reviews-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    /*
      Show "Write a review" only when Judge.me really offers its own write-review form:
      web reviews are not disabled in Judge.me AND its .jdgm-write-rev-link exists and is visible
      (ignoring the Judge.me header/summary parts this section hides on purpose). Judge.me renders the
      link briefly inside a hidden widget and then removes it when web reviews are off, so this keeps
      re-checking and hides the button again whenever the link is gone or hidden. The button opens that form.
    */
    var OWN_HIDDEN = '.jdgm-rev-widg__title, .jdgm-row-stars, .jdgm-rev-widg__summary, .jdgm-histogram, .jdgm-rev-widg__header';
    function webReviewsDisabled() {
      var s = window.jdgmSettings;
      return !!(s && (s.disable_web_reviews === true || s.disable_web_reviews === 'true'));
    }
    function usableLink(widget) {
      if (webReviewsDisabled()) return null;
      var links = widget.querySelectorAll('.jdgm-write-rev-link');
      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        if (!link.isConnected) continue;
        var ok = true;
        for (var el = link; el && el !== widget; el = el.parentElement) {
          var cs = window.getComputedStyle(el);
          if (cs.visibility === 'hidden' && el === link) { ok = false; break; }
          if (cs.display === 'none' && !(el.matches && el.matches(OWN_HIDDEN))) { ok = false; break; }
        }
        if (ok) return link;
      }
      return null;
    }
    function wire(section) {
      if (section.wpReviewsBox) return;
      section.wpReviewsBox = true;
      var btn = section.querySelector('[data-wp-rb-write]');
      var widget = section.querySelector('[data-wp-rb-widget]');
      if (!btn || !widget) return;
      btn.hidden = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = usableLink(widget);
        if (!link) { btn.hidden = true; return; }
        link.click();
        var form = widget.querySelector('.jdgm-form-wrapper, .jdgm-form');
        var target = form || widget;
        if (window.WP && typeof window.WP.scrollToWithHeader === 'function') window.WP.scrollToWithHeader(target, 12);
      });
      var tries = 0;
      var check = function () {
        btn.hidden = !usableLink(widget);
        if (++tries < 30) setTimeout(check, 500);
      };
      check();
    }
    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      Array.prototype.forEach.call(scope.querySelectorAll('[data-wp-reviews-box]'), wire);
      if (root && root.matches && root.matches('[data-wp-reviews-box]')) wire(root);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    /*
      Moves the heading (+ button) into Judge.me's summary panel as its title (top left) and shows the score in the design format.
      "Write a review" only shows when Judge.me offers its own write-review form (web reviews enabled and
      its .jdgm-write-rev-link is there and not hidden by Judge.me); it then opens that form.
    */
    function webReviewsDisabled() {
      var s = window.jdgmSettings;
      return !!(s && (s.disable_web_reviews === true || s.disable_web_reviews === 'true'));
    }
    function usableLink(widget) {
      if (webReviewsDisabled()) return null;
      var links = widget.querySelectorAll('.jdgm-write-rev-link');
      for (var i = 0; i < links.length; i++) {
        var link = links[i], ok = true;
        for (var el = link; el && el !== widget; el = el.parentElement) {
          var cs = window.getComputedStyle(el);
          if ((cs.visibility === 'hidden' && el === link) || cs.display === 'none') { ok = false; break; }
        }
        if (ok) return link;
      }
      return null;
    }
    function wire(section) {
      if (section.wpReviews) return;
      section.wpReviews = true;
      var cta = section.querySelector('[data-wp-rv-cta]');
      var widget = section.querySelector('[data-wp-rv-widget]');
      var btn = section.querySelector('[data-wp-rv-write]');
      if (!widget) return;
      var rating = section.getAttribute('data-rating');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var link = usableLink(widget);
          if (!link) { btn.hidden = true; return; }
          link.click();
          var form = widget.querySelector('.jdgm-form-wrapper, .jdgm-form');
          if (window.WP && typeof window.WP.scrollToWithHeader === 'function') window.WP.scrollToWithHeader(form || widget, 12);
        });
      }
      var tries = 0;
      var check = function () {
        var header = widget.querySelector('.jdgm-rev-widg__header');
        if (header && cta && cta.parentElement !== header) header.insertBefore(cta, header.firstChild);
        var avg = widget.querySelector('.jdgm-rev-widg__summary-average');
        if (avg && rating && avg.textContent !== rating) avg.textContent = rating;
        if (btn) btn.hidden = !usableLink(widget);
        if (++tries < 30) setTimeout(check, 500);
      };
      check();
    }
    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      Array.prototype.forEach.call(scope.querySelectorAll('[data-wp-reviews]'), wire);
      if (root && root.matches && root.matches('[data-wp-reviews]')) wire(root);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-support"] && !Shopify.designMode) return;
  try {
    
  /* Hash-driven pill tabs (#faqs / #shipping / #contact).
     The shared wafflepupz.js handles [data-wp-tabs] too; this is an idempotent fallback that
     keeps `hidden`, `.is-active` and aria state in sync so the panels always switch. */
  (function () {
    var KEYS = ['faqs', 'shipping', 'contact'];

    function init(root) {
      if (!root || root.dataset.wpSupportReady) return;
      root.dataset.wpSupportReady = '1';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wp-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-wp-panel]'));

      function keyFromHash() {
        var key = (location.hash || '').slice(1);
        return KEYS.indexOf(key) > -1 ? key : (root.getAttribute("data-wp-tabs-active") || KEYS[0]);
      }

      function show(key) {
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-wp-tab') === key;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-wp-panel') === key;
          panel.hidden = !on;
          panel.classList.toggle('is-active', on);
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-wp-tab');
          history.replaceState(null, '', '#' + key);
          show(key);
        });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (next) {
            event.preventDefault();
            next.focus();
            next.click();
          }
        });
      });

      window.addEventListener('hashchange', function () {
        show(keyFromHash());
      });

      show(keyFromHash());
    }

    function run() {
      document.querySelectorAll('[data-wp-support]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
